// Lógica compartida de los formularios de "Mi cuenta" (Datos bancarios,
// Editar perfil): avisos de éxito / error, barra de guardado que no queda
// tapada por el aviso de cookies, botón de WhatsApp por encima de la barra en
// celular y aviso del navegador si se cierra con cambios sin guardar.
//
// La página que lo usa tiene que tener: `hayCambios` (computed), `cargando`
// (data) y una `.bk-bar` dentro de su raíz. El estilo está en bkCuenta.css.

import { avisar, quitarAviso } from '@/Utils/notificaciones';

const AVISO_OK_MS = 5000;
const AVISO_VALIDACION_MS = 4500;


export default {
    data() {
        return {
            aviso: null,
            avisoTimer: null,
            cookiesAlto: 0,
        };
    },
    watch: {
        // La barra recién existe cuando termina la carga.
        cargando(v) {
            if (!v) this.$nextTick(this.observarBarra);
        },
        cookiesAlto() {
            this.barraObservada = null;
            this.$nextTick(this.observarBarra);
        },
    },
    methods: {
        // Los avisos salen con el cartel de las notificaciones del sitio (avisar()),
        // con sonido. `aviso` queda en null: el bk-toast de cada página ya no se pinta.
        // Los errores al guardar llevan "Reintentar" y duran más.
        mostrarAviso(tipo, texto, reintentar = null, { validacion = false } = {}) {
            clearTimeout(this.avisoTimer);
            this.aviso = null;
            quitarAviso(this.avisoId);
            this.avisoId = avisar({
                tipo: tipo === 'ok' ? 'ok' : 'error',
                titulo: texto,
                accion: reintentar ? { label: this.$t('datos_bancarios.toast.retry'), fn: reintentar } : null,
                duracion: tipo === 'ok' ? AVISO_OK_MS : (validacion ? AVISO_VALIDACION_MS : 12000),
            });
        },
        cerrarAviso() {
            clearTimeout(this.avisoTimer);
            this.aviso = null;
            quitarAviso(this.avisoId);
        },

        alSalir(e) {
            if (!this.hayCambios) return;
            e.preventDefault();
            e.returnValue = '';
        },

        // El aviso de cookies (fijo abajo, 58–92 px según el ancho) taparía la
        // barra de guardado hasta que se acepte: se mide y la barra y los
        // avisos se corren hacia arriba lo justo (variable --bk-cookies).
        medirCookies() {
            const banner = document.querySelector('.cookie-footer');
            this.cookiesAlto = banner ? Math.round(banner.getBoundingClientRect().height) : 0;
            if (this.cookiesRO) this.cookiesRO.disconnect();
            if (banner && typeof ResizeObserver !== 'undefined') {
                this.cookiesRO = new ResizeObserver(() => {
                    this.cookiesAlto = Math.round(banner.getBoundingClientRect().height);
                });
                this.cookiesRO.observe(banner);
            }
        },

        // Alto de la barra + cookies en una variable del <html> que usa la regla
        // del botón de WhatsApp (html.bk-page, en bkCuenta.css).
        observarBarra() {
            const barra = this.$el && this.$el.querySelector('.bk-bar');
            if (!barra || this.barraObservada === barra) return;
            if (this.barraRO) this.barraRO.disconnect();
            this.barraObservada = barra;
            const medir = () => {
                const alto = Math.round(barra.getBoundingClientRect().height) + this.cookiesAlto;
                document.documentElement.style.setProperty('--bk-bar-alto', alto + 'px');
            };
            medir();
            if (typeof ResizeObserver !== 'undefined') {
                this.barraRO = new ResizeObserver(medir);
                this.barraRO.observe(barra);
            }
        },
    },
    mounted() {
        window.addEventListener('beforeunload', this.alSalir);
        // El aviso de cookies es hijo directo de #page (App.vue): basta con
        // mirar esa lista de hijos, sin recorrer todo el árbol.
        this.medirCookies();
        const app = document.getElementById('page');
        if (app && typeof MutationObserver !== 'undefined') {
            this.cookiesMO = new MutationObserver(this.medirCookies);
            this.cookiesMO.observe(app, { childList: true });
        }
        document.documentElement.classList.add('bk-page');
        this.$nextTick(this.observarBarra);
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.alSalir);
        clearTimeout(this.avisoTimer);
        if (this.cookiesMO) this.cookiesMO.disconnect();
        if (this.cookiesRO) this.cookiesRO.disconnect();
        if (this.barraRO) this.barraRO.disconnect();
        document.documentElement.classList.remove('bk-page');
        document.documentElement.style.removeProperty('--bk-bar-alto');
    },
};
